export const SET_USER = 'SET_USER'

export const SET_CHANNEL = 'SET_CHANNEL'

export const SET_FAVOURITECHANNEL = 'SET_FAVOURITECHANNEL'

export const REMOVE_FAVOURITECHANNEL = 'REMOVE_FAVOURITECHANNEL'